import { CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { first, map } from 'rxjs';
import { PermissionsFacade } from '@core/permissions/facades/permissions.facade';
import { Permission } from '@core/permissions/models/permission.enum';
import { TopNavigationPath } from '@core/navigation/models/top-navigation/top-navigation-path';
import { ReportCardTabPath } from '@pages/report-card/models/report-card-tab-path.enum';

export const hasSummaryAccessGuard: CanMatchFn = () => {
  const router = inject(Router);
  const permissionFacade = inject(PermissionsFacade);

  return permissionFacade.permissionsLoaded$.pipe(
    first(),
    map(() => {
      if (permissionFacade.hasPermission(Permission.AbsorbLearningSummary)()) {
        return true;
      }

      return router.createUrlTree([`${TopNavigationPath.Home}/report-card/${`${ReportCardTabPath.MyCourses}`}`]);
    })
  );
};
